import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import Utils from '../../common/helpers/Utils';
import { DataActions, DataCategories, DataEvents } from '../../types/enum';
import { getQuote } from './QuoteSlice';

function Review(props: any) {
  const quoteData = useSelector(getQuote);
  const { type } = props;
  const cover: any = [];
  let index = 0;
  const [showDetail, setShowDetail] = useState(type !== 'summary');
  const { innerStep, step: outerStep } = quoteData.step;

  if (quoteData.quote.json && quoteData.quote.json.levelsOfCover) {
    Object.keys(quoteData.quote.json.levelsOfCover).forEach((coverKey: any) => {
      cover[index] = cover[index] || [];
      cover[index].push({
        key: coverKey,
        data: quoteData.quote.json.levelsOfCover[coverKey],
      });

      index = Math.floor((cover[index].length + 1) / 3);
    });

    if (quoteData.quote.json.showInceptionData && quoteData.quote.json.inceptionDate) {
      cover[index] = cover[index] || [];
      cover[index].push({
        key: 'Cover Inception Date',
        data: {
          summary: new Date(quoteData.quote.json.inceptionDate).toLocaleDateString('en-GB'),
        },
      });
      index = Math.floor((cover[index].length + 1) / 3);
    }
    if (quoteData.quote.json.hasRetroactiveCover) {
      cover[index] = cover[index] || [];
      cover[index].push({
        key: 'Retroactive cover as standard',
        data: {
          summary: 'Free',
        },
      });
      index = Math.floor((cover[index].length + 1) / 3);
    }
  }

  return (
    <>
      { Object.prototype.hasOwnProperty.call(quoteData.quote, 'json')
            && type !== 'summary' && !quoteData.quote.json.message
            && (
            <div className="row">
              <div className="v2-review-details-panel col-md-6 col-12 kb-border-end px-5">
                <h3 className="pb-4 mb-4">Your quote is ready</h3>
                <div className="price-card my-3">
                  <div className="price-card__header price-card--dark p-3">
                    <span className="price-card__label">
                      Net premium:
                    </span>
                    <span className="price-card__cost ps-3">
                      £
                      {quoteData.quote.json.priceSummary.gross_premium}
                    </span>
                  </div>
                </div>
                <div className="row">
                  <div>
                    <span className="fw-bold my-2 d-block">
                      {quoteData.quote.json.priceSummary.ipt_sub_heading}
                    </span>
                  </div>

                  <div className="col-md-8 col-12">
                    <span className="">
                      Package premium
                    </span>
                  </div>
                  <div className="col-md-4 col-12 text-end">
                    <span className="">
                      £
                      {quoteData.quote.json.priceSummary.package_premium}
                    </span>
                  </div>

                  {quoteData.quote.json.priceSummary.endorsements
                  && quoteData.quote.json.priceSummary.endorsements
                    .map((endorsment: any, endorsementIndex: number) => (
                      < >
                        <div className="col-md-8 col-12">
                          <span className="">
                            {endorsment.name}
                          </span>
                        </div>
                        <div className="col-md-4 col-12 text-end">
                          <span className="">
                            £
                            {endorsment.value}
                          </span>
                        </div>
                      </>
                    ))}

                  {quoteData.quote.json.priceSummary.fixed_discount > 0
                  && (
                  <>
                    <div className="col-md-8 col-12">
                      <span className="">
                        Discount
                      </span>
                    </div>
                    <div className="col-md-4 col-12 text-end">
                      <span className="">
                        - £
                        {quoteData.quote.json.priceSummary.fixed_discount}
                      </span>
                    </div>
                  </>
                  )}

                  <div className="col-md-8 col-12">
                    <span className="">
                      Insurance Premium Tax (IPT) (
                      {quoteData.quote.json.priceSummary.ipt_rate}
                      %)
                    </span>
                  </div>
                  <div className="col-md-4 col-12 text-end">
                    <span className="">
                      £
                      {quoteData.quote.json.priceSummary.ipt_amount}
                    </span>
                  </div>

                  {quoteData.quote.json.priceSummary.non_insurance_costs > 0
                    && (
                      <>
                        <div>
                          <span className="fw-bold my-2 d-block">
                            {quoteData.quote.json.priceSummary.vat_sub_heading}
                          </span>
                        </div>

                        <div className="col-md-8 col-12">
                          <span className="">
                            {quoteData.quote.json.priceSummary.reviews_name}
                          </span>
                        </div>
                        <div className="col-md-4 col-12 text-end">
                          <span className="">
                            £
                            {quoteData.quote.json.priceSummary.non_insurance_costs}
                          </span>
                        </div>

                        <div className="col-md-8 col-12">
                          <span className="">
                            VAT (
                            {quoteData.quote.json.priceSummary.vat_rate}
                            %)
                          </span>
                        </div>
                        <div className="col-md-4 col-12 text-end">
                          <span className="">
                            £
                            {quoteData.quote.json.priceSummary.vat_amount}
                          </span>
                        </div>
                      </>
                    )}
                </div>
                <div className="price-card my-3">
                  <div className="price-card__header price-card--dark p-3">
                    <span className="">
                      Payment options
                    </span>
                  </div>
                  <div className="price-card__content price-card--light p-3">
                    <div className="d-flex justify-content-between">
                      <div className="">
                        <h5 className="pb-2 pb-sm-0 mb-0">SINGLE PAYMENT</h5>
                        <span className="price-card__cost price-card__cost--large">
                          £
                          {quoteData.quote.json.priceSummary.lump_sum_total}
                        </span>
                      </div>
                      <div className="price-card__divider" />
                      <div className="">
                        <h5 className="pb-2 pb-sm-0 mb-0">10 MONTHLY PAYMENTS</h5>
                        <span className="price-card__cost price-card__cost--large">
                          £
                          {quoteData.quote.json.priceSummary.instalment_price}
                        </span>
                        <small>
                          includes
                          {' '}
                          {quoteData.quote.json.priceSummary.monthly_price}
                          % transaction fee*
                        </small>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="col-md-6 col-12 px-5">
                <h4 className="pb-4 mb-4">Levels of cover</h4>
                <div className="row">
                  {cover.map((coverDetail: any, coverIndex: number) => (
                    <div className="col-md-6 col-12" key={coverIndex}>
                      {coverDetail.map((coverData: any) => (
                        <div key={coverData.key}>
                          <span className="fw-bold mb-2 d-block">
                            {coverData.key}
                          </span>
                          <p className="ps-4 ps-sm-0" dangerouslySetInnerHTML={{ __html: coverData.data.summary.replace('{value}', decodeURIComponent(coverData.data.value)) }} />
                          {coverData.data.excess && <p dangerouslySetInnerHTML={{ __html: coverData.data.excess.replace('{value}', decodeURIComponent(coverData.data.value)) }} />}
                          {coverData.data.exclusion && <p dangerouslySetInnerHTML={{ __html: coverData.data.exclusion.replace('null', decodeURIComponent(coverData.data.exclusion)) }} />}
                        </div>
                      ))}
                    </div>
                  ))}

                </div>
                <h4 className="pb-4 mb-4">Documents</h4>
                <div className="row">
                  {quoteData.quote.json.documents && quoteData.quote.json.documents.map(
                    (document: any, documentIndex: number) => (

                      <div className="col-md-6 col-12 documents mb-2" key={documentIndex}>
                        <a target="_blank" href={`/admin/assets/docs/${document.filename}`} rel="noreferrer">
                          {document.title}
                        </a>
                      </div>
                    ),
                  )}

                </div>
              </div>
            </div>
            )}
      {Object.prototype.hasOwnProperty.call(quoteData.quote, 'json')
            && quoteData.quote.json.message
            && (
            <div className="container quote--form">
              <div className="alert alert-info mx-auto mt-5 quote--form">
                <h2>Oops, there was a problem</h2>
                <p
                  className="terms"
                  style={{ textAlign: 'left' }}
                  dangerouslySetInnerHTML={{
                    __html: quoteData.quote.json.message.replace(
                      'you can click \'continue\'',
                      'you can select to continue',
                    ).replace('\r\n', '<br>'),
                  }}
                />
              </div>
            </div>
            )}
      {Object.prototype.hasOwnProperty.call(quoteData.quote, 'json')
            && type === 'summary'
            && Object.prototype.hasOwnProperty.call(quoteData.quote.json, 'priceSummary')
            && Object.prototype.hasOwnProperty.call(quoteData.quote.json.priceSummary, 'lump_sum_total')
            && Object.prototype.hasOwnProperty.call(quoteData.quote.json.priceSummary, 'instalment_price')
            && Object.prototype.hasOwnProperty.call(quoteData.quote.json.priceSummary, 'ipt_rate')
            && (
            <div className="quote-summary p-3">
              <div className={`container ${showDetail ? 'd-none' : 'd-block'}`}>
                <div className="row">
                  <div className="col-12 col-md-6">
                    <h5 className="quote-summary__heading pb-0 mb-0">YOUR quote summary</h5>
                    <div className="quote-summary__content d-flex justify-content-between">
                      <div className="">
                        <span className="pb-2 pb-sm-0 mb-0 title">Single Payment</span>
                        <span className="price-card__cost price-card__cost--large">
                          £
                          {quoteData.quote.json.priceSummary.lump_sum_total}
                        </span>
                      </div>
                      <div className="price-card__divider" />
                      <div className="">
                        <span className="pb-2 pb-sm-0 mb-0 title">10 Monthly payments</span>
                        <span className="price-card__cost price-card__cost--large">
                          £
                          {quoteData.quote.json.priceSummary.instalment_price}
                        </span>
                        <small>
                          includes
                          {' '}
                          {quoteData.quote.json.priceSummary.monthly_price}
                          % transaction fee*
                        </small>
                      </div>
                    </div>
                  </div>
                  <div className="col-12 mt-3 mt-md-0 col-md-6">
                    <div className="d-flex justify-content-end align-content-center">
                      <button
                        type="button"
                        onClick={() => {
                          Utils.sendDataLayerEvent({
                            event:
                              DataEvents[DataEvents.analyticsEvent],
                            eventCategory:
                              DataCategories[DataCategories['Quote Journey']],
                            eventAction:
                              DataActions[DataActions['View detailed summary']],
                            stepNumber: outerStep + 1,
                            stepName: quoteData.steps[(outerStep)].steps[innerStep].title,
                          });
                          setShowDetail(true);
                        }}
                        className="btn btn--green ms-4 px-5 align-self-end py-3 px-4"
                      >
                        View detailed summary
                      </button>
                    </div>
                  </div>
                </div>
              </div>
              <div className={`container ${showDetail ? 'd-block' : 'd-none'}`}>
                <button
                  type="button"
                  onClick={() => {
                    setShowDetail(false);
                  }}
                  className="btn-close btn-close-white float-end"
                  aria-label="Close"
                />
                <div className="quote-summary__expanded-details row">
                  <div className="quote-summary__quote-panel col-md-6 col-12 kb-border-end px-5">
                    <h3 className="pb-4 mb-4">Your quote is ready</h3>
                    <div className="price-card my-3">
                      <div className="price-card__header price-card--dark p-3">
                        <span className="price-card__label">
                          Net premium:
                        </span>
                        <span className="price-card__cost ps-3">
                          £
                          {quoteData.quote.json.priceSummary.gross_premium}
                        </span>
                      </div>
                    </div>
                    <div className="row">
                      <div>
                        <span className="fw-bold my-2 d-block">
                          {quoteData.quote.json.priceSummary.ipt_sub_heading}
                        </span>
                      </div>

                      <div className="col-md-8 col-12">
                        <span className="">
                          Package premium
                        </span>
                      </div>
                      <div className="col-md-4 col-12 text-end">
                        <span className="">
                          £
                          {quoteData.quote.json.priceSummary.package_premium}
                        </span>
                      </div>

                      {quoteData.quote.json.priceSummary.endorsements
                        && quoteData.quote.json.priceSummary.endorsements
                          .map((endorsment: any, endorsementIndex: number) => (
                            < >
                              <div className="col-md-8 col-12">
                                <span className="">
                                  {endorsment.name}
                                </span>
                              </div>
                              <div className="col-md-4 col-12 text-end">
                                <span className="">
                                  £
                                  {endorsment.value}
                                </span>
                              </div>
                            </>
                          ))}

                      {quoteData.quote.json.priceSummary.fixed_discount > 0
                        && (
                          <>
                            <div className="col-md-8 col-12">
                              <span className="">
                                Discount
                              </span>
                            </div>
                            <div className="col-md-4 col-12 text-end">
                              <span className="">
                                - £
                                {quoteData.quote.json.priceSummary.fixed_discount}
                              </span>
                            </div>
                          </>
                        )}

                      <div className="col-md-8 col-12">
                        <span className="">
                          Insurance Premium Tax (IPT) (
                          {quoteData.quote.json.priceSummary.ipt_rate}
                          %)
                        </span>
                      </div>
                      <div className="col-md-4 col-12 text-end">
                        <span className="">
                          £
                          {quoteData.quote.json.priceSummary.ipt_amount}
                        </span>
                      </div>

                      {quoteData.quote.json.priceSummary.non_insurance_costs > 0
                        && (
                          <>
                            <div>
                              <span className="fw-bold my-2 d-block">
                                {quoteData.quote.json.priceSummary.vat_sub_heading}
                              </span>
                            </div>

                            <div className="col-md-8 col-12">
                              <span className="">
                                {quoteData.quote.json.priceSummary.reviews_name}
                              </span>
                            </div>
                            <div className="col-md-4 col-12 text-end">
                              <span className="">
                                £
                                {quoteData.quote.json.priceSummary.non_insurance_costs}
                              </span>
                            </div>

                            <div className="col-md-8 col-12">
                              <span className="">
                                VAT (
                                {quoteData.quote.json.priceSummary.vat_rate}
                                %)
                              </span>
                            </div>
                            <div className="col-md-4 col-12 text-end">
                              <span className="">
                                £
                                {quoteData.quote.json.priceSummary.vat_amount}
                              </span>
                            </div>
                          </>
                        )}
                    </div>

                    <div className="price-card my-3">
                      <div className="price-card__header price-card--dark p-3">
                        <span className="">
                          Payment options
                        </span>
                      </div>
                      <div className="price-card__content price-card--light p-3">
                        <div className="d-flex justify-content-between">
                          <div className="">
                            <h5 className="pb-2 pb-sm-0 mb-0">SINGLE PAYMENT</h5>
                            <span className="price-card__cost price-card__cost--large">
                              £
                              {quoteData.quote.json.priceSummary.lump_sum_total}
                            </span>
                          </div>
                          <div className="price-card__divider" />
                          <div className="">
                            <h5 className="pb-2 pb-sm-0 mb-0">10 MONTHLY PAYMENTS</h5>
                            <span className="price-card__cost price-card__cost--large">
                              £
                              {quoteData.quote.json.priceSummary.instalment_price}
                            </span>
                            <small>
                              includes
                              {' '}
                              {quoteData.quote.json.priceSummary.monthly_price}
                              % transaction fee*
                            </small>
                          </div>
                        </div>
                      </div>
                    </div>

                    <div className="row">
                      <h4 className="mt-4 mb-4 ">Documents</h4>
                      {quoteData.quote.json.documents.map(
                        (document: any, documentIndex: number) => (
                          <div className="col-md-6 col-12 documents" key={documentIndex}>
                            <a target="_blank" href={`/admin/assets/docs/${document.filename}`} rel="noreferrer">
                              {document.title}
                            </a>
                          </div>
                        ),
                      )}
                    </div>
                  </div>
                  <div className="quote-summary__levels-panel col-md-6 col-12 px-5">
                    <h4 className="pb-4 mb-4">Levels of cover</h4>
                    <div className="row">
                      {cover.map((coverDetail: any, coverIndex: number) => (
                        <div className="col-md-6 col-12" key={coverIndex}>
                          {coverDetail.map((coverData: any) => (
                            <div key={coverData.key}>
                              <span className="fw-bold mb-2 d-block">
                                {coverData.key}
                              </span>
                              <p
                                className="ps-4 ps-sm-0"
                                dangerouslySetInnerHTML={{ __html: coverData.data.summary.replace('{value}', decodeURIComponent(coverData.data.value)) }}
                              />
                              {coverData.data.excess
                                 && <p dangerouslySetInnerHTML={{ __html: coverData.data.excess.replace('{value}', decodeURIComponent(coverData.data.value)) }} />}

                            </div>
                          ))}
                        </div>
                      ))}

                    </div>

                  </div>
                </div>
              </div>
            </div>
            )}
    </>
  );
}

export default Review;
